module.exports = __webpack_public_path__ + "media/images/responsive/page_common/button_cp-0e26ab6c24898560fe6807b0a4b9d103.png";